import Checkbox from 'antd/lib/checkbox'
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { WHITE, BLUE, GRAY_DARK, GRAY_SKELETON, GRAY_ANTDESIGN } from '../../theme/colors'

interface DivProps {
  disabled?: boolean
}

export const ModalContainer = styled.div`
  display: flex;
  flex-flow: column;
`

export const BodyContent = styled.div`
  padding: 0 30px 10px 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`

export const InputContainer = styled.div`
  flex: 1;
  padding: 20px 0;
`

export const Title = styled.div`
  font-size: 16px;
  padding: 30px;
  padding-bottom: 15px;
  text-align: left;
  font-weight: bold;
  @media (max-width: 480px) {
    font-size: 16px;
  }
`

export const Description = styled.div`
  font-size: 16px;
  padding: 0px 30px;
  margin-bottom: 20px;
  text-align: left;
  font-family: Avenir;
  line-height: 1.25;
  @media (max-width: 480px) {
    font-size: 14px;
  }
`

export const Footer = styled(Description)`
  margin-bottom: 25px;

  a {
    color: ${BLUE};
  }
`

export const Strong = styled.div`
  font-weight: 600;
  font-size: 15px;
  text-align: center;
`

export const PhoneColumn = styled.div`
  display: block;
  margin-left: 10px;
`

export const InputTitleContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
  @media (max-width: 412px) {
    justify-content: center;
  }
`

export const Label = styled.div`
  height: 19px;
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 32px;
  @media (max-width: 698px) {
    flex-flow: column;
    margin-left: 0;
  }
`

export const CloseButton = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  padding: 6px 12px;
  border: 1px solid #cecece;
  border-radius: 3px;
  box-shadow: 1px 2px 5px -2px #a4a4a4;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ConfirmButton = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  padding: 6px 12px;
  border: 1px solid #cecece;
  border-radius: 3px;
  margin-left: 20px;
  box-shadow: 1px 2px 5px -2px #a4a4a4;
  transition: all .25s;
  background: ${BLUE};
  color: ${WHITE};
  border: 1px solid ${BLUE};
  &:hover {
    cursor: pointer;
    color: ${BLUE};
    background: ${WHITE};
  }
  ${({ disabled }: DivProps) => disabled ? `
    background: ${GRAY_ANTDESIGN};
    border: 1px solid ${GRAY_ANTDESIGN};
    &:hover {
      opacity: 1;
      background: ${GRAY_ANTDESIGN};
      color: ${WHITE};
      cursor: not-allowed;
    }
  ` : ''}
  @media (max-width: 698px) {
    margin-left: 0px;
  }
`

export const BannerImage = styled.img`
  max-width: 336px;
  object-fit: contain;
  @media (max-width: 480px) {
    width: 100%;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  color: ${GRAY_DARK};
  text-indent: -24px;
  margin: 20px 0px 0 24px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export const OptOutMessage = styled.div`
  margin-top: 14px;
  font-size: 12px;
`

export const TelInput = styled.div`
  display: inline-flex;
  align-items: flex-start;
  @media (max-width: 412px) {
    flex-flow: column;
    align-items: center;
    width: 100%;
  }
`

export const StyledSignUp = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: -2px;
  padding: 9px 12px;
  background: ${({ disabled }: DivProps) => disabled ? GRAY_SKELETON : BLUE};
  color: ${WHITE};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: ${({ disabled }: DivProps) => disabled ? 'not-allowed' : 'pointer'};
    opacity: 0.7;
  }
  @media (max-width: 412px) {
    margin: 0;
    margin-top: 12px;
    width: 100%;
    border-radius: 3px;
    justify-content: center;
    max-width: 192px;
  }
`

export const SignUpIcon = styled(Icon)`
  margin-right: 10px;
`

export const SavedDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SavedPhone = styled.img`
  width: 100%;
  max-width: 378px;
  filter: brightness(1.1);
  margin: 28px 32px;
  object-fit: contain;
  animation: fade-in-fwd 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-fwd {
    0% {
      transform: translateZ(-80px);
      opacity: 0;
    }
    100% {
      transform: translateZ(0);
      opacity: 1;
    }
  }
`

export const PromptTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  font-family: Avenir;
  margin-bottom: 10px;
  color: ${GRAY_DARK};
`

export const okButtonStyles = {
  background: BLUE,
  border: 'none',
  borderRadius: '2px'
}

export const InfoText = styled.div`
  margin-left: -38px;
  margin-bottom: 4px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ExternalShippingModal/styledComponents.tsx